import type { RouteLocationNormalized } from 'vue-router'
import { useLocalStorageStore } from "@/stores/localStorage"
import { SCOPE } from "@/stores/models/localStorage"
import { isUserAuthenticated } from '@/auth'

interface Guard {
    (to: RouteLocationNormalized, from: RouteLocationNormalized, next: any): void
}

function operate(
    guards: Guard[],
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    lastNext: any,
    i: number
) {
  const guard = guards[i]
    if (guards.length === i + 1) {
        guard(to, from, lastNext)
    } else {
        guard(to, from, function (nextArg: any) {
            switch (typeof (nextArg)) {
                case 'undefined':
                    operate(guards, to, from, lastNext, i + 1)
                    break
                case 'object':
                    lastNext(nextArg)
                    break
                case 'boolean':
                    lastNext(nextArg)
                    break
                case 'string':
                    lastNext(nextArg)
                    break
            }
        })
    }
}

export function multiGuards (guards: Guard[]) {
    return <Guard>function (to, from, next) {
        operate(guards, to, from, next, 0)
    }
}


// GUARDS
export const scopeGuard: Guard = (to, from, next) => {
    return useLocalStorageStore().getScope == null && to.name !== "PageNotFound"
        ? next({ name: "PageNotFound" })
        : next()
}

export const redirectToLoginGuard: Guard = (to, from, next) => {
    switch (useLocalStorageStore().getScope) {
        case SCOPE.TECH:
            next({ 
                name: "Tech",
                query: to.query
            })
            break
        case SCOPE.FINANCE:
            next({
                name: "Finance",
                query: to.query
            })
            break
        default:
            next({ name: "PageNotFound" })
            break
    }        
}

export const authGuard: Guard = (to, from, next) => {
    if (!isUserAuthenticated()) {   
        return redirectToLoginGuard(to, from, next)
    } else
        next();
}